/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePayJunctionRequest
 */
export interface UpdatePayJunctionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePayJunctionRequest
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePayJunctionRequest
     */
    password: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePayJunctionRequest
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the UpdatePayJunctionRequest interface.
 */
export function instanceOfUpdatePayJunctionRequest(value: object): value is UpdatePayJunctionRequest {
    if (!('userName' in value) || value['userName'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function UpdatePayJunctionRequestFromJSON(json: any): UpdatePayJunctionRequest {
    return UpdatePayJunctionRequestFromJSONTyped(json, false);
}

export function UpdatePayJunctionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePayJunctionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userName': json['userName'],
        'password': json['password'],
        'enabled': json['enabled'],
    };
}

export function UpdatePayJunctionRequestToJSON(json: any): UpdatePayJunctionRequest {
    return UpdatePayJunctionRequestToJSONTyped(json, false);
}

export function UpdatePayJunctionRequestToJSONTyped(value?: UpdatePayJunctionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userName': value['userName'],
        'password': value['password'],
        'enabled': value['enabled'],
    };
}

